export default "__VITE_ASSET__DbE3nNWV__"